var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRefuelling = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4 4.778v-.89c0-.49.398-.888.889-.888h1.778c.49 0 .889.398.889.889v.889h4.665c.43 0 .847.156 1.17.44l3.053 2.67 2.949 2.58c.386.338.607.826.607 1.339V19c0 .982-.796 1.778-1.778 1.778H5.778A1.78 1.78 0 0 1 4 19zm7.432 2.412a.89.89 0 0 1 1.255-.066l4.624 4.164c.365.328.395.89.066 1.255l-.594.66a.89.89 0 0 1-1.256.066l-4.624-4.163a.89.89 0 0 1-.066-1.256zm-.32 9.143a2.222 2.222 0 1 1-4.445 0c0-1.227 1.11-3.333 2.222-4.444 1.111 1.11 2.222 3.217 2.222 4.444m-.715-1.063c.078.26.112.518.12.757.024.726-.412.886-.51.167a5 5 0 0 0-.154-.754 5 5 0 0 0-.29-.725c-.314-.647.14-.755.517-.142.125.203.24.437.317.697",
  clipRule: "evenodd"
})));
export default SvgRefuelling;